import type { Notification } from '@repo/types/types/notification'
import { formatDistanceToNow } from 'date-fns'

/**
 * Hook for notification core logic
 * Provides computed properties and actions for notification components
 */
export function useNotificationCore(
  notification: Notification,
  onMarkAsRead?: (id: string) => void
) {
  const handleMarkAsRead = () => {
    if (onMarkAsRead) {
      onMarkAsRead(notification.id)
    }
  }

  const handleMarkAsReadWithEvent = (e: React.MouseEvent) => {
    e.stopPropagation()
    handleMarkAsRead()
  }

  return {
    // Core notification data
    notification,

    // Computed properties
    isUnread: !notification.read,
    formattedTimestamp: formatDistanceToNow(new Date(notification.createdAt), {
      addSuffix: true,
    }),

    // Actions
    handleMarkAsRead,
    handleMarkAsReadWithEvent,
  }
}
